//include 28
jQuery(function(){
    var pubSubElement = $({});
    var pubSub = {
        subscribe : function() {
            pubSubElement.on.apply(pubSubElement, arguments);
            return this;
        },
        unsubscribe : function() {
            pubSubElement.off.apply(pubSubElement, arguments);
            return this;
        },
        publish : function() {
            pubSubElement.trigger.apply(pubSubElement, arguments);
            return this;
        },
        events: {
            //availabilityReady:"availabilityReady",
            serviceSearchReady:"serviceSearchReady",
            cartUpdated:"cartUpdated",
            filtersReady:"filtersReady",
            loader: "loader",
            checkBookmarks: "checkBookmarks",
            cartRedirect: "cartRedirect",
            availabilityReady: "availabilityReady",
            slidersEventChange:"range-slider:change",
            slidersEventEnable:"range-slider:enable",
            slidersEventDisable:"range-slider:disable",
            belegungChange:"belegung:change",
            airBnBSearch:"airBnB:change",
            switchHide:"switch:hide",
            switchClass:"switch:class",
            initAirBnBMap:"airBnB:init",
            switchSetDefault:"switchSetDefault",
            toggleOpenBefore: "toggleOpenBefore",
            toggleOpenAfter: "toggleOpenAfter",
            toggleCloseBefore: "toggleCloseBefore",
            toggleCloseAfter: "toggleCloseAfter",
            modalOpen: "lityModalOpen",
            categoryChanged: "categoryChanged"
        }
    }
    window.pixelpoint.pubSub = pubSub;
});